import { jsxs as v, jsx as a } from "react/jsx-runtime";
import * as t from "react";
import { cn as f } from "../../../lib/utils.js";
const w = t.forwardRef(({ children: b, height: s, maxHeight: n, variant: c = "default", trackColor: r, thumbColor: l, className: i }, d) => {
  const e = "var(--scrollbar-thumb)", o = {
    default: {
      scrollbarWidth: "thin",
      scrollbarColor: `${l || e} ${r || "var(--bg-muted)"}`
    },
    thin: {
      scrollbarWidth: "thin",
      scrollbarColor: `${l || e} transparent`
    },
    thick: {
      scrollbarWidth: "auto",
      scrollbarColor: `${l || e} ${r || "var(--bg-muted)"}`
    },
    invisible: {
      scrollbarWidth: "none",
      msOverflowStyle: "none"
    }
  };
  return v("div", { ref: d, className: f("overflow-auto", {
    default: "scrollbar scrollbar-track-bg-muted scrollbar-thumb-lpr-teal scrollbar-thumb-rounded-full scrollbar-track-rounded-full",
    thin: "scrollbar-thin scrollbar-track-transparent scrollbar-thumb-lpr-teal scrollbar-thumb-rounded-full",
    thick: "scrollbar-thick scrollbar-track-bg-muted scrollbar-thumb-lpr-teal scrollbar-thumb-rounded-full scrollbar-track-rounded-full",
    invisible: "scrollbar-none"
  }[c], i), style: {
    height: s,
    maxHeight: n,
    ...o[c]
  }, children: [a("style", { children: `
          :root {
            --scrollbar-thumb: hsl(var(--lpr-teal));
            --scrollbar-thumb-hover: hsl(var(--lpr-teal) / 0.8);
          }
          .dark {
            --scrollbar-thumb: hsl(var(--lpr-gold));
            --scrollbar-thumb-hover: hsl(var(--lpr-gold) / 0.8);
          }

          .scrollbar::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          .scrollbar::-webkit-scrollbar-track {
            background: ${r || "var(--bg-muted)"};
            border-radius: 100vh;
          }
          .scrollbar::-webkit-scrollbar-thumb {
            background: ${l || "var(--scrollbar-thumb)"};
            border-radius: 100vh;
          }
          .scrollbar::-webkit-scrollbar-thumb:hover {
            background: ${l || "var(--scrollbar-thumb-hover)"};
          }

          .scrollbar-thin::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          .scrollbar-thin::-webkit-scrollbar-track {
            background: transparent;
          }
          .scrollbar-thin::-webkit-scrollbar-thumb {
            background: ${l || "var(--scrollbar-thumb)"};
            border-radius: 100vh;
          }

          .scrollbar-thick::-webkit-scrollbar {
            width: 12px;
            height: 12px;
          }
          .scrollbar-thick::-webkit-scrollbar-track {
            background: ${r || "var(--bg-muted)"};
            border-radius: 100vh;
          }
          .scrollbar-thick::-webkit-scrollbar-thumb {
            background: ${l || "var(--scrollbar-thumb)"};
            border-radius: 100vh;
          }

          .scrollbar-none::-webkit-scrollbar {
            display: none;
          }
        ` }), b] });
});
w.displayName = "CustomScrollbar";
const g = t.forwardRef(({ children: b, showScrollButtons: s = !1, className: n }, c) => {
  const r = t.useRef(null), [l, i] = t.useState(!1), [d, e] = t.useState(!1), o = () => {
    if (r.current) {
      const { scrollLeft: u, scrollWidth: k, clientWidth: p } = r.current;
      i(u > 0), e(u < k - p);
    }
  };
  t.useEffect(() => (o(), window.addEventListener("resize", o), () => window.removeEventListener("resize", o)), []);
  const h = () => {
    r.current && r.current.scrollBy({ left: -200, behavior: "smooth" });
  }, m = () => {
    r.current && r.current.scrollBy({ left: 200, behavior: "smooth" });
  };
  return v("div", { ref: c, className: f("relative", n), children: [s && l && a("button", { onClick: h, className: "absolute left-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-[var(--bg-surface)] border border-[var(--border-color)] rounded-full shadow-card hover:shadow-luxury transition-all text-[var(--text-primary)]", children: a("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: a("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M15 19l-7-7 7-7" }) }) }), a("div", { ref: r, onScroll: o, className: "flex overflow-x-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-rounded-full", style: { scrollbarColor: "var(--scrollbar-thumb) transparent" }, children: b }), s && d && a("button", { onClick: m, className: "absolute right-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-[var(--bg-surface)] border border-[var(--border-color)] rounded-full shadow-card hover:shadow-luxury transition-all text-[var(--text-primary)]", children: a("svg", { className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: a("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 5l7 7-7 7" }) }) })] });
});
g.displayName = "HorizontalScrollbar";
export {
  w as CustomScrollbar,
  g as HorizontalScrollbar
};
//# sourceMappingURL=CustomScrollbar.js.map
